export default __webpack_public_path__ + "static/media/man1.ba1980cf.svg";